/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-img-element */
import { FC, useCallback, useRef, useState } from 'react';
import { useReducedMotion } from 'motion/react';
import { twMerge } from 'tailwind-merge';

const ImagesCarousel: FC<{
	images: {
		src: string;
		alt: string;
		caption?: string;
	}[];
}> = ({ images }) => {
	const scrollRef = useRef<HTMLDivElement>(null);
	const reduceMotion = useReducedMotion();

	const [currentlyCenteredIndex, setCurrentlyCenteredIndex] = useState(0);

	const scrollImageIntoView = useCallback(
		(index: number, width: number) => {
			scrollRef.current?.scrollTo({
				left: index * width,
				behavior: reduceMotion ? 'auto' : 'smooth',
			});
		},
		[reduceMotion],
	);

	return (
		<div
			ref={scrollRef}
			className="-my-28 snap-x snap-mandatory overflow-x-auto overflow-y-visible px-4 py-36"
			style={{
				scrollbarWidth: 'none',
			}}
			onScroll={(event) => {
				const itemWidth =
					event.currentTarget.children[0].children[0].clientWidth;
				const scrollPosition = event.currentTarget.scrollLeft;
				const index = Math.round(scrollPosition / itemWidth);

				setCurrentlyCenteredIndex(index);
			}}
		>
			<ul className="flex min-w-max pe-[100vw] ps-[calc(50vw-32rem)]">
				{images.map((image, index) => (
					<li
						key={image.src}
						className="relative snap-mandatory snap-center"
					>
						<img
							role="presentation"
							src={image.src}
							alt=""
							aria-hidden="true"
							className={twMerge(
								'absolute inset-0 size-full rounded-3xl  blur-3xl saturate-200 transition-all duration-1000',
								index === currentlyCenteredIndex
									? 'opacity-100 dark:opacity-50'
									: 'opacity-25 dark:opacity-10',
							)}
						/>
						{image.caption !== undefined && (
							<p
								className={twMerge(
									'absolute -bottom-1.5 inset-x-2 sm:bottom-3 sm:inset-x-3 z-10 rounded-xl bg-white text-slate-700 px-2 md:px-3 py-0.5 md:text-lg shadow-md md:-bottom-2 md:start-4 md:end-auto motion-safe:transition-all',
									index !== currentlyCenteredIndex &&
										'opacity-0 scale-75',
								)}
							>
								{image.caption}
							</p>
						)}
						<img
							src={image.src}
							alt={
								image.caption !== undefined
									? `${image.caption} - ${image.alt}`
									: image.alt
							}
							className={twMerge(
								'relative h-full w-[52rem] max-w-[calc(100vw-5rem)] sm:max-w-[65vw] cursor-pointer object-cover rounded-3xl shadow-lg motion-safe:transition-all',
								index === currentlyCenteredIndex
									? 'scale-100'
									: 'scale-90 hover:scale-95',
							)}
							style={{
								imageRendering: 'crisp-edges',
							}}
							tabIndex={0}
							onClick={(event) =>
								scrollImageIntoView(
									index,
									event.currentTarget.clientWidth,
								)
							}
							onFocus={(event) =>
								scrollImageIntoView(
									index,
									event.currentTarget.clientWidth,
								)
							}
						/>
					</li>
				))}
			</ul>
		</div>
	);
};

export default ImagesCarousel;
